import React from 'react';
import Button from 'components/common/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { useIsDisabled, useIsShowOrderButton } from './hooks';
import { handleOrderButtonClick } from './orderButtonActions';

const OrderButton = () => {
  const isShow = useIsShowOrderButton();
  const isDisabled = useIsDisabled();
  if (!isShow) return null;
  return (
    <Button
      onClick={handleOrderButtonClick}
      disabled={isDisabled}
      className="nav-bar-button"
      type="button"
      size="lg"
      textSize="md"
      rounded
      color="azure"
    >
      <span>Continue</span>
      <FontAwesomeIcon.Memo icon={faArrowRight} />
    </Button>
  );
};

export default OrderButton;
